export default {
  ['language-cn']: '中文',
  ['language-en']: 'English',
  ['change-language']: '切换语言'
}
